import moment from 'moment';

const clean_up_date = ($date) => {
  return moment($date).format("MMM Do YYYY");
}

export default clean_up_date;